import { createSelector } from "reselect";
import { initialState } from "./reducer";


const selectSubmittedCasesDetailsPageDomain = state =>
  state.submittedCasesDetailsPage || initialState;

const makeSelectSubmittedCasesDetailsPage = () =>
  createSelector(
    selectSubmittedCasesDetailsPageDomain,
    substate => substate
  );

const makeSelectCaseData = () =>
  createSelector(
    selectSubmittedCasesDetailsPageDomain,
    substate => substate.caseDetails
  );

export default makeSelectSubmittedCasesDetailsPage;
export { selectSubmittedCasesDetailsPageDomain, makeSelectCaseData };
